import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import i18next, { changeLanguage } from "i18next";
import { useQuery } from "@apollo/client";
import { loginGQL, useLegacyMutation } from "@onmo/graphql/legacyGraphql";
import { meGQL } from "@onmo/graphql/graphql";
import { selectIsAuthenticated, updateSignInState } from "@onmo/auth";

import { ReturnNotification } from "../components/common/ReturnNotification";
import { InAppNotification } from "../components/common/InAppNotification";
import { NotificationSubscription } from "../components/common/NotificationSubscription";
import { useAppSelector } from "../components/hooks";
import { useRefetchNotification } from "../hooks/resolvers/notification/useRefetchNotification";
import GamingLoading from "../components/common/GamingLoading/GamingLoading";
import { useNotificationManager } from "../hooks/resolvers/notification/useNotificationManager";
import { useArticleContentView } from "../hooks/useArticleContentView";
import { PageRoutes } from "../constants/historyGaming";

const AuthenticatedLayout = () => {
  const location = useLocation();
  const [login] = useLegacyMutation(loginGQL);
  const at = (p: string) => location.pathname.startsWith(p);
  const { data: dataMe, loading: loadingMe } = useQuery(meGQL);
  const { language } = useRefetchNotification();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const { userNotifications, inAppNotificationData, shouldShowPopup } =
    useNotificationManager();
  useArticleContentView();

  // Sync Language
  useEffect(() => {
    if (language && i18next.language !== language) {
      changeLanguage(language);
    }
  }, [language]);

  useEffect(() => {
    login().then(() => updateSignInState());
  }, [login]);

  if (isAuthenticated && !dataMe) return <GamingLoading />;
  if (
    isAuthenticated &&
    !loadingMe &&
    dataMe?.me?.metadata &&
    !JSON.parse(dataMe.me.metadata.onboarding || "{}")
      .hasCheckedUserNameAvatar &&
    !at(PageRoutes.SetProfile)
  ) {
    return <Navigate to={PageRoutes.SetProfile} replace />;
  }

  return (
    <>
      {shouldShowPopup && (
        <ReturnNotification userNotifications={userNotifications} />
      )}
      {inAppNotificationData && <InAppNotification />}
      <NotificationSubscription />
      <Outlet />
    </>
  );
};

export default AuthenticatedLayout;
